import PromoIcon from "app/components/Icon/components/IconPromotionalPage/PromoIcon";
import React from "react";

interface PromoItemProps {
  index: number;
  title: string;
  text: string;
}

const PromoItem: React.FC<PromoItemProps> = ({ index, title, text }) => {
  return (
    <div className="promo-item">
      {/* SVG Icon */}
      <div className="promo-item-icon">
        <PromoIcon index={index} />
      </div>

      {/* Title and Text */}
      <div className="promo-item-content">
        <h3 className="promo-item-title">{title}</h3>
        <p className="promo-item-text">{text}</p>
      </div>
    </div>
  );
};

export default PromoItem;
